import { actionTypes } from '../actions/types';
import { errorNames } from '../util/mappings/errorName';

type AppActions = import('../actions/types').AppActions;

export interface VehicleReducer {
    vehicleDetails?: {
        chassisNumber?: string | null;
        co2?: string | null;
        engineVolume?: number | null;
        fuel?: string | null;
        importedUsed?: boolean | null;
        make?: string | null;
        manufactureYear?: number | null;
        manufacturer?: string | null;
        model?: string | null;
        netWeightKg?: number | null;
        powerRatingHp?: number | null;
        powerRatingKw?: number | null;
        priceQuote?: number | null;
        registrationNumber?: string | null;
        registrationYear?: number | null;
        totalWeightKg?: number | null;
        transmission?: string | null;
        vehicleGroupNr?: string | null;
        wheelPropulsion?: string | null;
    };
    vehicleErrorNoMatch: boolean;
}

export const initialState: VehicleReducer = {
    vehicleDetails: {
        chassisNumber: null,
        co2: null,
        engineVolume: null,
        fuel: null,
        importedUsed: null,
        make: null,
        manufactureYear: null,
        manufacturer: null,
        model: null,
        netWeightKg: null,
        powerRatingHp: null,
        powerRatingKw: null,
        priceQuote: null,
        registrationNumber: null,
        registrationYear: null,
        totalWeightKg: null,
        transmission: null,
        vehicleGroupNr: null,
        wheelPropulsion: null,
    },
    vehicleErrorNoMatch: false,
};

export const vehicleReducer = (state = initialState, action: AppActions = {} as AppActions): VehicleReducer => {
    switch (action.type) {
        case actionTypes.FETCH_VEHICLE_INFO_FULFILLED:
        case actionTypes.SEND_APPLICATION_FULFILLED:
        case actionTypes.FETCH_APPLICATION_FULFILLED:
        case actionTypes.UPDATE_APPLICATION_FULFILLED: {
            return {
                ...state,
                vehicleDetails: {
                    ...state.vehicleDetails,
                    ...action.payload?.vehicleDetails,
                },
                vehicleErrorNoMatch: false,
            };
        }
        case actionTypes.FETCH_ONGOING_APPLICATIONS_EUROTAX_CLEAR: {
            return {
                ...state,
                ...initialState,
            };
        }

        case actionTypes.FETCH_VEHICLE_INFO_FAILED: {
            const { errorName } = action.payload;
            return {
                ...state,
                ...initialState,
                vehicleErrorNoMatch: errorName === errorNames.vehicleRegNoNotFound,
            };
        }
        default:
            return state;
    }
};
